import Position, { IPosition } from './Position';

export interface IPage {
  id: string;
  positions: Position[];
  imageUrl: string;
}

class Page {
  public readonly id: string;
  public readonly positions: Position[];
  public readonly imageUrl: string;

  constructor({ id, positions, imageUrl }: { id: string; positions: Position[]; imageUrl: string }) {
    this.id = id;
    this.positions = positions;
    this.imageUrl = imageUrl;
  }

  public toJSON = () => ({
    id: this.id,
    positions: this.positions,
    imageUrl: this.imageUrl,
  });

  public static fromJSON = (json: IPage): Page => {
    const { id, positions, imageUrl } = Object.assign({}, json);

    if (typeof id !== 'string') throw new Error('.id must be a string');
    if (typeof imageUrl !== 'string') throw new Error('.imageUrl must be a string');
    const _positions = positions.map((comment: IPosition) => {
      return Position.fromJSON(comment);
    });

    return new Page({
      id,
      positions: _positions,
      imageUrl,
    });
  };
}

export default Page;
